// extracted by mini-css-extract-plugin
export default {"servantList":"servant_list_servantList__seECy","Mui-focused":"servant_list_Mui-focused__BVNvH","label":"servant_list_label__J36LF"};